<!-- Legacy section bar. Pages listed in showNavbar()'s fullHeightPages render
     <ui-page-header> instead (WB-7275).

     The AI Copilot branches below are dead: this bar no longer renders on
     /quotations, the only route they applied to. Removal is tracked in
     WB-7763; see applyCopilot() in the component for the full checklist. -->
<div class="nav_container" *ngIf="showNavbar()">
  <div *ngIf="!isOrganize()" [class]="!enableLogo() ? 'flex_x_center' : 'title'">
    <div class="logo_img" *ngIf="!enableLogo()">
      <img src="assets/icones/Logo-Volta.svg" alt="" class="big_logo" />
    </div>
    <img class="icon_title" src="{{ navbarParams.icon }}" alt="" *ngIf="enableLogo() && !((isCopilot$ | async) && currentUrl === '/quotations')" />
    <div class="descr_title">
      <div class="top_title">
        <h3 class="page_title m-0" [ngClass]="{ 'copilot-title': (isCopilot$ | async) && currentUrl === '/quotations' }">
          <button *ngIf="(isCopilot$ | async) && currentUrl === '/quotations'" class="back-button" (click)="applyCopilot()">
            <img src="assets/icones/close_icon.svg" alt="" />
          </button>
          {{ "breadcrumbs." + navbarParams.title | translate }}
          <img src="assets/icones/arrow_to_right.svg" alt="" *ngIf="(isCopilot$ | async) && currentUrl === '/quotations'" />
          <span *ngIf="(isCopilot$ | async) && currentUrl === '/quotations'" class="page_title is_copilot_title">
            {{ isCopilotTitle }}
          </span>
        </h3>
        <span class="hint_block" *ngIf="showHint()">
          <mat-icon style="color: #0ab890">info</mat-icon>
          <span class="hint_span">{{ hintTitle() }}</span>
        </span>
      </div>
      <div class="list_title" *ngIf="navbarParams.breadcrumbs.length > 0">
        <!-- <div class="current_page">
          <span>{{setTitle()}}</span>
          <img src="assets/icones/arrow_to_right.svg" alt="">
          <span>{{currentTitle()}}</span>
        </div> -->
        <!-- <div class="current_page" *ngIf="!((isCopilot$ | async) && currentUrl === '/quotations')">
          <div class="breadcrumb" *ngFor="let breadcrumb of navbarParams.breadcrumbs; let last = last">
            <ng-container *ngIf="!last">
              <span class="breadcrumb_span" (click)="navigateTo(breadcrumb.url!)"> {{"breadcrumbs." + breadcrumb.label | translate}} </span>
              <img src="assets/icones/arrow_to_right.svg" alt="">
            </ng-container>
            <ng-container *ngIf="last">
              <span class="active_path" >{{"breadcrumbs." + breadcrumb.label | translate}}</span>
              <span class="active_path" *ngIf="breadcrumb.label === 'list'">({{totalElement}})</span>
            </ng-container>
          </div>
        </div> -->
        <div class="current_page" *ngIf="navbarParams.parentPath !== null">
          <div class="back_block" (click)="back()">
            <span class="back_span">{{ "common.back" | translate | uppercase | uppercase }}</span>
            <img src="../../../assets/icones/arrow_back_small.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="filter_block">
    <!-- Search Input -->
    <div class="search_block" *ngIf="canShowSearchInput()">
      <input
        type="text"
        class="search_input"
        [placeholder]="searchPlaceholder() | translate"
        [formControl]="searchInput"
        [readonly]="(isAppLoading$ | async) === true"
      />
      <img src="assets/icones/search.svg" class="indicate_input" alt="" />
    </div>
    <div class="search_block" *ngIf="currentUrl === '/suppliers'">
      <input
        type="text"
        class="search_input"
        [placeholder]="('common.search' | translate) + ' ' + ('suppliers.supplier' | translate)"
        [formControl]="searchSupplierInput"
        [readonly]="(isAppLoading$ | async) === true"
      />
      <img src="assets/icones/search.svg" class="indicate_input" alt="" />
    </div>

    <!-- Export Buttons -->
    <button class="add_btn" *ngIf="currentUrl === '/companies'" (click)="exportCustomers()">
      <img src="assets/icones/export_icon.svg" alt="" />
      <span>{{ "common.export" | translate }}</span>
    </button>
    <ng-container *ngIf="currentUrl === '/orders'">
      <button class="add_btn" (click)="exportOrders()" *appHasPermission="{ module: 'order' }">
        <img src="assets/icones/export_icon.svg" alt="" />
        <span>{{ "common.export" | translate }}</span>
      </button>

      <!-- ── Inbound order channel ── -->
      <div
        class="inbound-channel"
        *ngIf="{
          proc: (procCount$ | async) ?? 0,
          err: (errCount$ | async) ?? 0,
          total: (total$ | async) ?? 0,
          active: (active$ | async) ?? false,
          visible: (showProcessing$ | async) ?? true
        } as ic"
        (mouseenter)="loadInboundChannel()"
      >
        <button
          type="button"
          class="inbound-channel__btn"
          [ngClass]="{
            'inbound-channel__btn--tinted': ic.active && ic.visible,
            'inbound-channel__btn--error': ic.err > 0
          }"
          [attr.aria-label]="
            (ic.active ? (ic.visible ? 'orders.inbound_channel.aria_hide' : 'orders.inbound_channel.aria_show') : 'orders.inbound_channel.aria_copy')
              | translate
          "
          [attr.aria-pressed]="ic.active ? !ic.visible : null"
          (click)="onChannelClick(ic.active)"
        >
          <ui-svg-icon svgIcon="at-sign" size="small"></ui-svg-icon>
          <span *ngIf="ic.active && ic.visible" class="volta-pulse inbound-channel__dot" [class.inbound-channel__dot--error]="ic.err > 0"></span>
          <span *ngIf="ic.active && !ic.visible" class="inbound-channel__badge" [class.inbound-channel__badge--error]="ic.err > 0">{{
            ic.total
          }}</span>
        </button>

        <div class="inbound-channel__menu">
          <div class="inbound-channel__popover">
            <!-- header -->
            <div class="inbound-channel__header">
              <ui-svg-icon svgIcon="at-sign" size="xsmall"></ui-svg-icon>
              <span class="inbound-channel__title">{{ "orders.inbound_channel.title" | translate }}</span>
              <span class="inbound-channel__live" *ngIf="ic.active">
                <span class="volta-pulse inbound-channel__live-dot"></span>
                {{ "orders.inbound_channel.live" | translate }}
              </span>
            </div>

            <!-- live breakdown -->
            <ng-container *ngIf="ic.active; else idleBlock">
              <div class="inbound-channel__section">
                <div class="inbound-channel__line">
                  <span class="volta-pulse inbound-channel__line-dot"></span>
                  <div>
                    <div class="inbound-channel__line-title">
                      {{
                        (ic.proc === 1 ? "orders.inbound_channel.analyzing" : "orders.inbound_channel.analyzing_plural")
                          | translate: { count: ic.proc }
                      }}
                    </div>
                    <div class="inbound-channel__line-detail">
                      {{ "orders.inbound_channel.analyzing_detail" | translate }}
                    </div>
                  </div>
                </div>
                <div class="inbound-channel__line" *ngIf="ic.err > 0">
                  <span class="inbound-channel__line-icon inbound-channel__line-icon--error">
                    <ui-svg-icon svgIcon="alert-circle-red" size="xsmall"></ui-svg-icon>
                  </span>
                  <div>
                    <div class="inbound-channel__line-title inbound-channel__line-title--error">
                      {{ "orders.inbound_channel.couldnt_process_count" | translate: { count: ic.err } }}
                    </div>
                    <div class="inbound-channel__line-detail">
                      {{ "orders.inbound_channel.couldnt_process_detail" | translate }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- visibility toggle -->
              <button type="button" class="inbound-channel__toggle" (click)="toggleVisibility()">
                <span class="inbound-channel__toggle-label">
                  {{
                    (ic.visible ? "orders.inbound_channel.pinned_to_top" : "orders.inbound_channel.hidden_from_list") | translate: { count: ic.total }
                  }}
                </span>
                <span class="inbound-channel__toggle-action">
                  {{ (ic.visible ? "orders.inbound_channel.click_to_hide" : "orders.inbound_channel.click_to_show") | translate }}
                </span>
              </button>

              <!-- address footer -->
              <div class="inbound-channel__footer">
                <span class="inbound-channel__footer-text">
                  {{ "orders.inbound_channel.via_address" | translate: { address: inboundChannel?.address || "" } }}
                </span>
                <button
                  type="button"
                  class="inbound-channel__copy-icon"
                  [class.inbound-channel__copy-icon--copied]="copied"
                  [attr.aria-label]="'orders.inbound_channel.aria_copy' | translate"
                  (click)="copyAddress()"
                >
                  {{ (copied ? "orders.inbound_channel.copied" : "orders.inbound_channel.copy") | translate }}
                </button>
              </div>
            </ng-container>

            <!-- idle -->
            <ng-template #idleBlock>
              <div class="inbound-channel__section">
                <div class="inbound-channel__description">
                  {{ "orders.inbound_channel.description" | translate }}
                </div>
                <div class="inbound-channel__address-group">
                  <div class="inbound-channel__address-label">
                    {{ "orders.inbound_channel.forwarding_address" | translate }}
                  </div>
                  <div class="inbound-channel__address-field">
                    <span class="inbound-channel__address">{{ inboundChannel?.address }}</span>
                    <button
                      type="button"
                      class="inbound-channel__copy"
                      [class.inbound-channel__copy--copied]="copied"
                      [attr.aria-label]="'orders.inbound_channel.aria_copy' | translate"
                      (click)="copyAddress()"
                    >
                      {{ (copied ? "orders.inbound_channel.copied" : "orders.inbound_channel.copy") | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="inbound-channel__received">
                {{ "orders.inbound_channel.received_last_7_days" | translate: { count: inboundChannel?.last7_count ?? 0 } }}
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Filter Buttons -->
    <div class="filter_btns" *ngIf="canShowAdvancedFilter()">
      <button class="filter" (click)="setFilter()">
        <img src="assets/icones/search-filter.svg" alt="" />
        <span>{{ "common.filter" | translate | titlecase }}</span>
      </button>
      <button class="clear" (click)="clearFilter()" *ngIf="hasModuleFilters()">
        <small>{{ "common.clear" | translate | titlecase }}</small>
        <img src="assets/icones/clear-filter.svg" alt="" />
      </button>
    </div>

    <!-- Add/Import Buttons -->
    <ng-container *ngIf="canDisplayAddButton()">
      <button class="add_btn" (click)="add()" *appHasPermission="addButtonPermission()">
        <img [src]="['/imports', '/comparators'].includes(currentUrl!) ? 'assets/icones/imports.svg' : 'assets/icones/add_icon.svg'" alt="" />
        <span>{{ ["/imports", "/comparators"].includes(currentUrl!) ? ("import.import" | translate) : ("common.add" | translate) }}</span>
      </button>
    </ng-container>
  </div>
  <!-- <button *ngIf="isCatalogDetailsPage()" class="share-button" aria-label="Share catalog" (click)="openShareCatalog()">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  <span>{{ 'Catalogs.share_catalog.share_button' | translate }}</span>
</button> -->
</div>
